import { queueMicroTask } from "./queueMicroTask";

var queueResizeObserver = function queueResizeObserver(cb) {
  queueMicroTask(function ResizeObserver() {
    requestAnimationFrame(cb);
  });
};

export { queueResizeObserver };